<template>
  <v-form ref="form" class="mx-2" method="post" enctype="multipart/form-data">
    <v-container id="CAPITOLISPESA" fluid tag="section">
      <v-row>
        <v-col :cols="isEditCapitoli ? '4' : '12'">
          <base-material-card
            color="white"
            iconcolor="darkred"
            icon="mdi-speaker-multiple"
            :title="$t('capitolispesa.titolo')"
            class="px-5 py-3"
          >
            <v-container v-if="isCreatedCorrectly" v-resize="onContainerChange">
              <v-row>
                <v-col>
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      :label="$t('capitolispesa.ricerca')"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                </v-col>
                <v-col align="end">
                  <v-btn color="darkred" width="150px" @click="onNuovoCapitolo">
                    <v-icon left> mdi-plus-circle-outline </v-icon>
                    {{ $t("capitolispesa.nuovoCapitolo") }}
                  </v-btn>
                  <v-btn color="darkred" width="180px" @click="onExportGrid" v-show="false">
                    <v-icon left> mdi-export </v-icon>
                    {{ $t("esporta") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-data-table
              style="max-height:600px; overflow:auto"
              id="tblCapitoli"
              :items="capitoliSpesa.source"
              :headers="headersColumns"
              :search="search"
              :value="[capitoliSpesa.selected]"
              @click:row="onTableRowClick"
              single-select
              :items-per-page="-1"
              class="elevation-1"
              :loading="isloading_dataTable"
              loading-text="Caricamento dati in corso..."
            >
            </v-data-table>
          </base-material-card>
        </v-col>

        <v-col v-if="isEditCapitoli" cols="8">
          <base-material-card
            color="white"
            iconcolor="darkred"
            icon="mdi-speaker"
            :title="
              $t('capitolispesa.numeroCapitolo') +
              ': ' +
              capitoliSpesa.selected.cNumeroCapitolo
            "
            class="px-5 py-3"
          >
            <v-card flat>
              <v-row>
                <v-card-title
                  class="black--text"
                  style="margin-bottom: 20px; margin-top: 20px"
                  >{{ $t("anagrafica") }}
                </v-card-title>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="capitoliSpesa.selected.cNumeroCapitolo"
                    :label="$t('capitolispesa.numeroCapitoloObbl')"
                    :rules="[rules.required]"
                    maxlength="20"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="capitoliSpesa.selected.cDescrizione"
                    :label="$t('capitolispesa.descrizioneObbl')"
                    :rules="[rules.required]"
                    maxlength="50"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    v-model="capitoliSpesa.selected.cFlagCdc"
                    :label="$t('capitolispesa.cdc')"
                    hide-details
                    :disabled="shouldDisable"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <v-select
                    :items="eEnti"
                    return-object
                    item-text="cDescrizione"
                    item-value="id"
                    :label="$t('capitolispesa.enteObbl')"
                    :rules="[rules.selectRequired]"
                    v-model="capitoliSpesa.selected.enteDTO"
                    :disabled="shouldDisable"
                    @change="onEnteChanged($event)"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row> </v-row>

              <v-divider class="mx-4"></v-divider>
              <v-row
                style="margin-top: 20px; margin-left: 20px; margin-bottom: 10px"
              >
                <v-alert
                  id="alertDettaglio"
                  shaped
                  :value="isAlertDetailVisible"
                  :type="alertType"
                  dismissible
                >
                  {{ messaggioAlert }}
                </v-alert>
              </v-row>

              <v-row
                style="margin-top: 20px; margin-left: 20px; margin-bottom: 10px"
              >
                <v-btn
                  tile
                  color="darkred"
                  v-if="!isHidden"
                  v-on:click="isHidden = true"
                  @click="onEditClick"
                >
                  <v-icon left> mdi-pencil </v-icon>
                  {{ $t("modifica") }}
                </v-btn>
                <v-btn
                  tile
                  color="darkred"
                  v-if="isHidden"
                  @click="onSaveClick"
                >
                  <v-icon left> mdi-content-save </v-icon>
                  {{ $t("salva") }}
                </v-btn>
                <v-btn tile color="darkred" @click="onDisattivaClick">
                  <v-icon left> mdi-delete </v-icon>
                  {{ $t("disattiva") }}
                </v-btn>
                <v-btn
                  id="btnChiudi"
                  tile
                  color="darkred"
                  @click="onCloseDetail"
                >
                  <v-icon left> mdi-door-open </v-icon>
                  {{ $t("chiudi") }}
                </v-btn>
                <v-dialog v-model="dialogDisattivaCapitolo" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Sei sicuro di voler disattivare il capitolo selezionato?
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="onCloseDisattivaCapitolo"
                        >Annulla</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="onConfirmDisattivaCapitolo"
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-card>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row>
        <v-alert
          id="alertGrid"
          shaped
          :value="isAlertGridVisible"
          :type="alertType"
          dismissible
        >
          {{ messaggioAlert }}
        </v-alert>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";

import i18n from "@/i18n";
import Utils from "@/utils/Utils";

import TipologicheService from "@/service/TipologicheService";
import EntiService from "@/service/EntiService";
import CapitoliService from "@/service/CapitoliService";

@Component
export default class CapitoliSpesa extends Vue {
  capitoliSpesa = {
    selected: null,
    source: [],
  };

  headersColumns = [
    {
      text: "Numero capitolo",
      align: "start",
      value: "cNumeroCapitolo",
    },
    { text: "Descrizione", value: "cDescrizione" },
    { text: "Ente", value: "enteDTO.cDescrizione" },
    { text: "CDC", value: "bFlagCdc" },
  ];

  isEditCapitoli = false;
  isNewCapitolo = false;
  isCreatedCorrectly = false;
  isAlertGridVisible = false;
  isAlertDetailVisible = false;
  isloading_dataTable = false;
  shouldDisable = true;
  enteShouldDisable = true;
  isHidden = false;
  saveClicked = false;
  isNewUser = false;
  dialogDisattivaCapitolo = false;

  capitoloTemplate = null;

  dimension = 0;

  messaggioAlert = "";
  alertType = "error";
  search = "";

  rules = Utils.rules;

  created() {
    let verLoadingPage = Utils.verifyLoadingPage(
      this.$store,
      "W_PROFILAZIONEUTENTE"
    );
    switch (verLoadingPage) {
      case 0: // All OK
        this.isCreatedCorrectly = true;
        var enteId = this.$store.state.enteSel.id;
        this.loadEnti();
        this.loadCapitoliSpesa(0, false);
        this.getTemplateCapitolo();
        break;

      case 1: // Utente non loggato
        AuthService.logout();
        break;

      case 2: // Ente non selezionato
        this.$router.push({ name: "Dashboard" });
        break;

      case 3: // Permesso alla pagina non presente
        this.$router.push({ name: "Dashboard" });
    }
  }

  onEditClick() {
    this.shouldDisable = false;
  }

  onDisattivaClick() {
    this.dialogDisattivaCapitolo = true;
  }

  onSaveClick() {
    // Verifico se i campi della form sono tutti validi.
    // Per funzionare nel template ci deve essere un oggetto di tipo V-FORM
    this.saveClicked = true;
    var formIsValid = this.$refs.form.validate();
    if (!formIsValid) {
      this.alertType = "error";
      // In caso di errore del salvataggio continuare con l'editing
      this.messaggioAlert = i18n.t("erroreCampiObbligatori");
      this.showHide_alertDetail(8000);
    } else {
      if (this.capitoliSpesa.selected.id > 0) {
        // Salvo il dato sul DB
        this.saveCapitoloDto(this.capitoliSpesa.selected.id);
      } else {
        // Creo il nuovo record
        this.createCapitoloDto();
      }
    }
  }

  onCloseDetail() {
    this.isEditCapitoli = false;
    this.onContainerChange();
    this.shouldDisable = true;
    this.isHidden = false;
  }

  onExportGrid() {
    // TODO
  }

  onNuovoCapitolo() {
    this.saveClicked = false;
    this.isNewCapitolo = true;
    this.isEditCapitoli = true;
    this.shouldDisable = false;
    this.isHidden = true;

    this.capitoliSpesa.selected = Object.assign({}, this.capitoloTemplate);

    this.onContainerChange();

    //this.manageEntiVisibility(true);

    this.onEnteChanged();

    this.$refs.form.resetValidation();
  }

  onTableRowClick(capitoloSel) {
    // Setto la riga selezionata
    this.capitoliSpesa.selected = capitoloSel;

    console.log("Capitolo Spesa selezionato: ");
    console.log(this.capitoliSpesa.selected);

    //this.manageEntiVisibility(false);
    // TODO

    this.shouldDisable = true;
    this.isEditCapitoli = true;
  }

  onContainerChange() {
    let self = this;
    // console.log("onContainerChange");
    self.$nextTick(function () {
      self.dimension = document.getElementById("tblCapitoli").offsetWidth;
      return self.dimension;
    });
  }

  onEnteChanged() {
    if (
      !Utils.isNullOrUndefined(this.capitoliSpesa.selected.enteDTO) &&
      this.capitoliSpesa.selected.enteDTO.id != -1
    ) {
      // TODO
    }
  }

  onCloseDisattivaCapitolo() {
    this.dialogDisattivaCapitolo = false;
  }

  onConfirmDisattivaCapitolo() {
    this.disattivaCapitoloDto(this.capitoliSpesa.selected.id);
    this.dialogDisattivaCapitolo = false;
  }

  showHide_alertGrid(millisecondInterval, event) {
    //console.log('Hide alert');
    this.isAlertGridVisible = true;
    // `event` is the native DOM event
    window.setTimeout(() => {
      this.isAlertGridVisible = false;
      console.log(
        "hide alert after " + millisecondInterval / 1000 + " seconds"
      );
    }, millisecondInterval);
  }

  showHide_alertDetail(millisecondInterval, event) {
    //console.log('Hide alert');
    this.isAlertDetailVisible = true;
    // `event` is the native DOM event
    window.setTimeout(() => {
      this.isAlertDetailVisible = false;
      //console.log("hide alert after " + millisecondInterval/1000 + " seconds");
    }, millisecondInterval);
  }

  manageEntiVisibility(isEditing) {
    // Gestione Utente / Profilazione
    if (this.$store.state.roleSel != null) {
      if (this.$store.state.roleSel.CCode == "ADM") {
        if (this.$store.state.enteSel.id == 0) {
          // Può selezionare
          // Abilito le select degli enti
          if (isEditing) this.enteShouldDisable = false;
          else this.enteShouldDisable = true;
        } else {
          // E' bloccato come un utente qualsiasi
          // Setto l'ente selezionato in Dashboard
          if (!Utils.isNullOrUndefined(this.capitoliSpesa.selected)) {
            this.capitoliSpesa.selected.eEnte = this.$store.state.enteSel;
            this.capitoliSpesa.selected.eEnteId = this.$store.state.enteSel.id;
            // Disabilito le select degli enti
            this.enteShouldDisable = true;
          }
        }
      } else {
        if (!Utils.isNullOrUndefined(this.capitoliSpesa.selected)) {
          this.capitoliSpesa.selected.eEnte = this.$store.state.enteSel;
          this.capitoliSpesa.selected.eEnteId = this.$store.state.enteSel.id;
        }
        // Disabilito le select degli enti
        this.enteShouldDisable = true;
      }
    }
  }

  /// ***********************
  /// DATABASE
  /// ***********************

  getTemplateCapitolo() {
    var self = this;

    CapitoliService.getTemplateCapitolo(
      (resp) => {
        console.log("getTemplateCapitolo:");
        console.log(resp);

        self.capitoloTemplate = resp;
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  loadCapitoliSpesa(enteId, storico) {
    var self = this;
    self.isloading_dataTable = true;
    CapitoliService.getCapitoliSpesa(
      enteId,
      storico,
      (resp) => {
        console.log("GetCapitoliSpesa");
        console.log(resp);

        self.capitoliSpesa.source = resp;
        self.isloading_dataTable = false;
      },
      (err) => {
        console.log("Errore GetCapitoliSpesa");
        console.log(err);
        self.isloading_dataTable = false;
      }
    );
  }

  loadCapitolo(id, onSuccess) {
    var self = this;

    CapitoliService.getCapitoloSpesa(
      id,
      (resp) => {
        console.log("Capitolo:");
        console.log(resp);

        self.veicoloSel = resp;

        for (let i = 0; i < self.veicoloSel.documenti.length; i++) {
          var item = self.veicoloSel.documenti[i];
          item.guid = Utils.createGuid();
          item.hIns = UtilsDate.convertStringToDate(item.hIns);
        }
        for (let i = 0; i < self.veicoloSel.scadenze.length; i++) {
          var item = self.veicoloSel.scadenze[i];
          item.guid = Utils.createGuid();
          item.hIns = UtilsDate.convertStringToDate(item.hIns);
        }
        if (typeof onSuccess === "function") onSuccess(resp);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertGrid(8000);
        //self.isloading_fornitori = false;
      }
    );
  }

  loadEnti(isEditing) {
    var self = this;
    if (isEditing) self.enteShouldDisable = true;

    EntiService.getEnti(
      (resp) => {
        console.log("GetEnti");
        console.log(resp);

        self.eEnti = resp;
      },
      (err) => {
        console.log("Errore GetEnti");
        console.log(err);
      }
    );
  }

  createCapitoloDto() {
    var self = this;

    CapitoliService.createCapitolo(
      self.capitoliSpesa.selected,
      (resp) => {
        console.log("createCapitolo");
        console.log(resp);
        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(5000);
          // Ricarico la griglia
          self.updateGridCapitoliSpesa(resp.idNewObject, null);
          self.isNewVeicolo = false;
          self.isHidden = !self.isHidden;
          self.shouldDisable = true;
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(8000);
        }
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  saveCapitoloDto(id) {
    var self = this;

    CapitoliService.updateCapitolo(
      self.capitoliSpesa.selected,
      (resp) => {
        console.log("updateCapitolo");
        console.log(resp);

        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(5000);
          // Aggiorno la griglia principale
          self.updateGridCapitoliSpesa(id);
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(8000);
        }

        self.isHidden = !self.isHidden;
        self.shouldDisable = true;
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  disattivaCapitoloDto(id) {
    var self = this;

    CapitoliService.deleteCapitolo(
      id,
      (resp) => {
        console.log("DeleteCapitolo");
        console.log(resp.data);
        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertGrid(5000);
          // Azzero l'oggetto
          self.capitoliSpesa.selected = null;
          // Ricarico la griglia
          self.onCloseDetail();
          self.loadCapitoliSpesa(0, false);
          console.log(resp.userMsg.message);
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(8000);
        }
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  updateGridCapitoliSpesa(id, onSuccess) {
    var self = this;

    CapitoliService.getCapitoloSpesa(
      id,
      (resp) => {
        console.log("Capitolo:");
        console.log(resp);

        var capitoloTmp = resp;
        if (typeof onSuccess === "function") onSuccess(resp);
        // Aggiorno la griglia
        var found = false;
        for (let i = 0; i < self.capitoliSpesa.source.length; i++) {
          var item = self.capitoliSpesa.source[i];
          if (item.id == id) {
            found = true;
            self.capitoliSpesa.source.splice(i, 1);
            self.capitoliSpesa.source.push(capitoloTmp);
            self.capitoliSpesa.selected = capitoloTmp;
            break;
          }
        }
        if (!found) {
          // Caso di nuovo oggetto
          self.capitoliSpesa.source.push(capitoloTmp);
          self.capitoliSpesa.selected = capitoloTmp;
        }
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertGrid(8000);
      }
    );
  }
}
</script>